import {ReactNode, useReducer} from 'react';

import {TasksImportContext} from './TasksImportContext';
import {taskImportReducer, getDefaultTaskImportContext} from './TasksImportState';

export function TasksImportProvider({children}: {children: ReactNode}) {
  const [state, dispatch] = useReducer(taskImportReducer, getDefaultTaskImportContext());
  return <TasksImportContext value={{...state, dispatch}}>{children}</TasksImportContext>;
}
